module.exports = __webpack_public_path__ + "static/media/71xMYOXUj7L._AC_UX569_.178b705e.jpg";